<button
  mat-stroked-button
  color="primary"
  [disabled]="!canInitiateCall()"
  [matTooltip]="tooltipText()"
  [class]="buttonClass()"
  (click)="onCallButtonClick()"
  type="button"
  aria-label="Initiate Call">

  <!-- Loading spinner when processing -->
  <mat-spinner
    *ngIf="isProcessing()"
    diameter="16"
    strokeWidth="2"
    class="processing-spinner">
  </mat-spinner>

  <!-- Call icon -->
  <mat-icon *ngIf="!isProcessing()" class="call-icon">call</mat-icon>

  <!-- Call text (optional) -->
  <span *ngIf="showTextValue() && !isProcessing()" class="call-text">Call</span>
</button>
